"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const globalErrorCode_1 = require("../global/model/error/globalErrorCode");
const transactionError_1 = require("./model/error/transactionError");
class Transaction {
    constructor(instance) {
        this.instance = instance;
    }
    getAllAssets(token) {
        return new Promise((resolve, reject) => {
            const URL = '/assets';
            if (!token) {
                reject(new transactionError_1.TransactionError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const bearer = 'Bearer '.concat(token);
            const config = { headers: { Authorization: bearer } };
            this.instance.get(URL, config)
                .then((res) => {
                const assets = res.data;
                resolve(assets);
            })
                .catch((err) => {
                reject(this.handleError_(err));
            });
        });
    }
    getAllActivities(token) {
        return new Promise((resolve, reject) => {
            const URL = '/activities';
            if (!token) {
                reject(new transactionError_1.TransactionError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const bearer = 'Bearer '.concat(token);
            const config = { headers: { Authorization: bearer } };
            this.instance.get(URL, config)
                .then((res) => {
                const assets = res.data;
                resolve(assets);
            })
                .catch((err) => {
                reject(this.handleError_(err));
            });
        });
    }
    getTotalActivities(token, code) {
        return new Promise((resolve, reject) => {
            const URL = `/activities/claimed/${code}`;
            if (!token) {
                reject(new transactionError_1.TransactionError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN));
                return;
            }
            const bearer = 'Bearer '.concat(token);
            const config = { headers: { Authorization: bearer } };
            this.instance.get(URL, config)
                .then((res) => {
                const assets = res.data;
                resolve(assets);
            })
                .catch((err) => {
                reject(this.handleError_(err));
            });
        });
    }
    handleError_(error) {
        if (error.response.data.message === 'Invalid token.') {
            return new transactionError_1.TransactionError(globalErrorCode_1.GlobalErrorCode.INVALID_TOKEN);
        }
        else {
            return new transactionError_1.TransactionError(globalErrorCode_1.GlobalErrorCode.UNDEFINED_CODE, error.response.data.message);
        }
    }
}
exports.Transaction = Transaction;
//# sourceMappingURL=transaction.js.map